import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
  ProduktRequested,
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';
import { ExtremwetterschutzSelbstbeteiligungValues } from '../model/extremwetterschutzSelbstbeteiligungValues.model';

export enum EXTREME_SB_REQUEST_EVENTS {
  REQUEST_SUCCESSFULL = 'REQUEST_SUCCESSFULL_VHV',
  REQUEST_FAILED = 'REQUEST_FAILED_VHV',
}

export function* extremwetterschutzSelbstbeteiligungSaga() {
  yield takeEvery(
    GlobalActions.PRODUKT_REQUESTED,
    safeSaga(getExtremSelbstbeteiligungValues, App.VHV_V2),
  );
  yield takeEvery(
    GlobalActions.PRODUKT_REQUESTED_AFTER_SAVE,
    safeSaga(getExtremSelbstbeteiligungValues, App.VHV_V2),
  );
  yield takeEvery(
    EXTREME_SB_REQUEST_EVENTS.REQUEST_SUCCESSFULL,
    safeSaga(successCallback, App.VHV_V2),
  );
}

export function* getExtremSelbstbeteiligungValues(action: GlobalAction<ProduktRequested>) {
  if (action.payload.appId === App.VHV_V2) {
    yield extremwetterschutzSelbstbeteiligungValuesRequest(action);
  } else {
    yield cancel();
  }
}

export function* extremwetterschutzSelbstbeteiligungValuesRequest(
  action: GlobalAction<ProduktRequested>,
) {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();

  if (action.payload.appId === App.VHV_V2 && action.payload.angebotsId === state.angebotsId) {
    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().doRequest({
        appId: App.VHV_V2,
        angebotsId: action.payload.angebotsId,
        method: HTTP_METHOD.GET,
        url: 'privatschutz/api/extremwetterschutzselbstbeteiligung/vhv2x',
        successEvent: EXTREME_SB_REQUEST_EVENTS.REQUEST_SUCCESSFULL,
        errorEvent: EXTREME_SB_REQUEST_EVENTS.REQUEST_FAILED,
      }),
    );
  } else {
    yield cancel();
  }
}

export function* successCallback(
  successAction: DoRequestResponse<ExtremwetterschutzSelbstbeteiligungValues[]>,
) {
  const state: IAppState = yield select();

  if (
    successAction.doRequestAction.payload.appId === App.VHV_V2 &&
    successAction.doRequestAction.payload.angebotsId === state.angebotsId
  ) {
    const globalPut = GlobalPut.getInstance();
    yield call(
      globalPut.put,
      new VhvActions().extremwetterschutzSelbstbeteiligungReceived(
        successAction.payload,
        successAction.doRequestAction.payload.angebotsId,
      ),
    );
  }
}
